import { atom } from 'jotai'

export const optimisticallyViewedTaskIdsAtom = atom<Set<string>>(
  new Set<string>()
)

export const adminViewEnabledAtom = atom<boolean>(false)
